import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {authOperations} from '../../reducks/auth';
import {commonOperations} from '../../reducks/common';
import withRouter from '../../components/organisms/withRouter';
import Login from '../../components/templates/Login';

const mapStateToProps = (state) => ({
  currentTheme: state.style.theme,
  formData: state.form,
});
const mapDispatchToProps = {
  loginAction: authOperations.doLoginOperation,
  logoutAction: authOperations.doLogoutOperation,
  doShowMessage: commonOperations.doShowMessage,
};

/**
 * ログイン画面
 * 画面ID:SCZ1001
 */
class App extends React.Component {
  async componentDidMount() {
    window.scrollTo(0, 0);
    // store初期化
    this.props.logoutAction();
  }

  render() {
    return (<Login
      {...this.props}
    />);
  }
}

const ContainerApp = connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(App));

App.propTypes = {
  logoutAction: PropTypes.func,
};

export default ContainerApp;
